import React, { useState } from 'react';
import { RawHtml } from '../../../../types/block';
import ReactQuill from 'react-quill';
import classNames from 'classnames';
import './htmlInput.module.scss';

type Props = {
  id?: string;
  value: RawHtml;
  placeholder?: string;
  error: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: RawHtml) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onBlur?: () => any;
  className?: string;
  styleName?: string;
};

export const HTMLInput = ({ id, value, placeholder, onChange, onBlur, error, className }: Props) => {
  const [focused, setFocused] = useState(false);
  return (
    <div styleName={classNames('html-input', { focused: focused, error: error })} className={className}>
      <ReactQuill
        id={id}
        value={value || ''}
        placeholder={placeholder}
        modules={{
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],
            ['link', 'clean'],
          ],
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setFocused(false);
          onBlur && onBlur();
        }}
        onChange={onChange}
      />
      <input
        type="text"
        id={`${id}-shadow`}
        value={value || ''}
        style={{ display: 'none' }}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    </div>
  );
};
